import React from 'react';
import ReactDOM from 'react-dom';
import SearchBar from './SearchBar';
interface IProp {
    qrcode?: string; // 右侧二维码图片
    selector: string; // id或者class
}

function renderSearchBar ({ qrcode, selector }: IProp) {
	const divContainer = document.createElement('div');
	const testRenderSearchBar = document.querySelector(selector);
	testRenderSearchBar.appendChild(divContainer);
	ReactDOM.render(
		<SearchBar qrcode={ qrcode }/>,
		divContainer,
	);
}

export {
	SearchBar,
	renderSearchBar
};
